export * from './classify-tickets-by-tag.template';
